import { Pencil2Icon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

import { Allowance } from "./schema";

import { useViewModal } from "../view-allowance-modal/use-view-modal";
import { useDeleteAllowanceModal } from "../delete-allowance-modal/use-delete-allowance-modal";
import { Trash } from "lucide-react";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as Allowance;

  const { onOpenChange: onViewOpen, setAllowanceRequest } = useViewModal();
  const { setAllowanceId, onOpenChange } = useDeleteAllowanceModal();

  return (
    <div className="flex items-center gap-3">
      <Button
        size="icon"
        className="w-6 h-6"
        onClick={() => {
          setAllowanceRequest(originData);
          onViewOpen(true);
        }}
      >
        <Pencil2Icon />
      </Button>

      <Button
        size="icon"
        variant="destructive"
        className="w-6 h-6"
        onClick={() => {
          setAllowanceId(originData?.id);
          onOpenChange(true);
        }}
      >
        <Trash className="w-4 h-4" />
      </Button>
    </div>
  );
}
